// Data attribute values for automated testing

export enum TestElementTypeId {
  AboutBackendVersion = 'ABOUT_BACKEND_VERSION',
  AboutContent = 'ABOUT_CONTENT',
  AboutContentImagesVersion = 'ABOUT_CONTENT_IMAGES_VERSION',
  AboutContentPartPeriod = 'ABOUT_CONTENT_PART_PERIOD',
  AboutContentResourcesVersion = 'ABOUT_CONTENT_RESOURCES_VERSION',
  AccordionAbout = 'ACCORDION_ABOUT',
  AccordionTermsAndCondition = 'ACCORDION_TERMS_AND_CONDITIONS',
  AccordionUploadConfig = 'ACCORDION_UPLOAD_CONFIG',
  AllViewDescriptionChevron = 'ALL_VIEW_DESCRIPTION_CHEVRON',
  AllViewGotItButton = 'All_VIEW_GOT_IT_BUTTON',
  AllViewTabsScrollLeftButton = 'ALL_VIEW_SCROLL_LEFT_BUTTON',
  AllViewTabsScrollRightButton = 'ALL_VIEW_SCROLL_RIGHT_BUTTON',
  AllViewTabsButton = 'ALL_VIEW_TABS_BUTTON',
  AllViewMenuLevel2 = 'ALL_VIEW_MENU_LEVEL_2',
  AllViewMenuLevel3 = 'ALL_VIEW_MENU_LEVEL_3',
  AllViewColourCard = 'ALL_VIEW_COLOUR_CARD',
  AllViewNonColourCard = 'ALL_VIEW_NON_COLOUR_CARD',
  AllViewSlideInImageButton = 'ALL_VIEW_SLIDE_IN_IMAGE_BUTTON',
  AllViewMaximizeImage = 'ALL_VIEW_MAXIMIZE_IMAGE',
  AllViewGetConsultationButton = 'ALL_VIEW_GET_CONSULTATION_BUTTON',
  AllViewSummaryButton = 'ALL_VIEW_SUMMARY_BUTTON',
  AllViewViewLessButton = 'ALL_VIEW_VIEW_LESS_BUTTON',
  AllViewDropDownLevel2 = 'ALL_VIEW_DROPDOWN_LEVEL_2',
  AllViewDropDownLevel3 = 'ALL_VIEW_DROPDOWN_LEVEL_3',
  AllViewColourCardLevel3 = 'ALL_VIEW_COLOUR_CARD_LEVEL_3',
  AllViewColourCardLevel4 = 'ALL_VIEW_COLOUR_CARD_LEVEL_4',
  BuildModeMainImage = 'BUILD_MODE_MAIN_IMAGE',
  ConsequenceOfChangeAcceptButton = 'CONSEQUENCE_OF_CHANGE_ACCEPT_BUTTON',
  DescriptionXmlUpload = 'DESCRIPTION_XML_UPLOAD',
  FactoryModelChoiceButton = 'FACTORY_MODEL_CHOICE_BUTTON',
  FactoryModelControlPanelDropDown = 'FACTORY_MODEL_CONTROL_PANEL_DROPDOWN',
  FactoryModelInfoIcon = 'FACTORY_MODEL_INFO_ICON',
  FactoryModelLoadingSpinner = 'FACTORY_MODEL_LOADING_SPINNER',
  FactoryModelTruckCardTitle = 'FACTORY_MODEL_TRUCK_CARD_TITLE',
  FactoryModelViewAllButton = 'FACTORY_MODEL_VIEW_ALL_BUTTON',
  FactoryModelViewAllNumberText = 'FACTORY_MODEL_VIEW_ALL_NUMBER_TEXT',
  GarageForgottenPasswordFormEmailAddressInput = 'GARAGE_FORGOTTEN_PASSWORD_FORM_EMAIL_ADDRESS_INPUT',
  GarageForgottenPasswordFormGotoLoginFormButton = 'GARAGE_FORGOTTEN_PASSWORD_FORM_GOTO_LOGIN_FORM_BUTTON',
  GarageForgottenPasswordFormGotoLoginFormButtonAfterEmailSent = 'GARAGE_FORGOTTEN_PASSWORD_FORM_GOTO_LOGIN_FORM_BUTTON_AFTER_EMAIL_SENT',
  GarageForgottenPasswordFormHeader = 'GARAGE_FORGOTTEN_PASSWORD_FORM_HEADER',
  GarageForgottenPasswordFormSubmitButton = 'GARAGE_FORGOTTEN_PASSWORD_FORM_SUBMIT_BUTTON',
  GarageLoginFormEmailAddressInput = 'GARAGE_LOGIN_FORM_EMAIL_ADDRESS_INPUT',
  GarageLoginFormGotoForgottenPasswordFormLink = 'GARAGE_LOGIN_FORM_GOTO_FORGOTTEN_PASSWORD_FORM_LINK',
  GarageLoginFormGotoRegistrationFormButton = 'GARAGE_LOGIN_FORM_GOTO_REGISTRATION_FORM_BUTTON',
  GarageLoginFormHeader = 'GARAGE_LOGIN_FORM_HEADER',
  GarageLoginFormPasswordInput = 'GARAGE_LOGIN_FORM_PASSWORD_INPUT',
  GarageLoginFormSubmitButton = 'GARAGE_LOGIN_FORM_SUBMIT_BUTTON',
  GarageRegistrationFormAcceptTermsCheckbox = 'GARAGE_REGISTRATION_FORM_ACCEPT_TERMS_CHECKBOX',
  GarageRegistrationFormEmailAddressInput = 'GARAGE_REGISTRATION_FORM_EMAIL_ADDRESS_INPUT',
  GarageRegistrationFormHeader = 'GARAGE_REGISTRATION_FORM_HEADER',
  GarageRegistrationFormPasswordInput = 'GARAGE_REGISTRATION_FORM_PASSWORD_INPUT',
  GarageRegistrationFormPasswordRepeatInput = 'GARAGE_REGISTRATION_FORM_PASSWORD_REPEAT_INPUT',
  GarageRegistrationFormSubmitButton = 'GARAGE_REGISTRATION_FORM_SUBMIT_BUTTON',
  GarageViewAccountTab = 'GARAGE_VIEW_ACCOUNT_TAB',
  GarageViewAccountTabContainer = 'GARAGE_VIEW_ACCOUNT_TAB_CONTAINER',
  GarageViewAccountViewGotoDeleteAccountFormButton = 'GARAGE_VIEW_ACCOUNT_VIEW_GOTO_DELETE_ACCOUNT_FORM_BUTTON',
  GarageViewAccountViewDeleteAccountSubmitButton = 'GARAGE_VIEW_ACCOUNT_VIEW_DELETE_ACCOUNT_SUBMIT_BUTTON',
  GarageViewAccountViewSignOutButton = 'GARAGE_VIEW_ACCOUNT_VIEW_SIGN_OUT_BUTTON',
  GarageViewGarageTab = 'GARAGE_VIEW_GARAGE_TAB',
  GarageViewGarageTabContainter = 'GARAGE_VIEW_GARAGE_TAB_CONTAINER',
  GarageViewGarageTabLoadTruckButton = 'GARAGE_VIEW_GARAGE_TAB_LOAD_TRUCK_BUTTON',
  GarageViewGarageTabLoadTruckSpinner = 'GARAGE_VIEW_GARAGE_TAB_LOAD_TRUCK_SPINNER',
  GarageViewGarageTabTruckCard = 'GARAGE_VIEW_GARAGE_TAB_TRUCK_CARD',
  GarageViewGarageTabTruckCardDetails = 'GARAGE_VIEW_GARAGE_TAB_TRUCK_CARD_DETAILS',
  GarageViewGarageTabTruckCardTitle = 'GARAGE_VIEW_GARAGE_TAB_TRUCK_CARD_TITLE',
  GuidedViewGotItButton = 'GUIDED_VIEW_GOT_IT_BUTTON',
  GuidedViewDescriptionChevron = 'GUIDED_VIEW_DESCRIPTION_CHEVRON',
  GuidedViewMaximizeImage = 'GUIDED_VIEW_MAXIMIZE_IMAGE',
  GuidedViewPopupSaveMenu = 'GUIDED_VIEW_POPUP_SAVE_MENU',
  GuidedViewPopupShareMenu = 'GUIDED_VIEW_POPUP_SHARE_MENU',
  GuidedViewGetConsultationButton = 'GUIDED_VIEW_GET_CONSULTATION_BUTTON',
  GuidedViewSummaryButton = 'GUIDED_VIEW_SUMMARY_BUTTON',
  GuidedViewViewAllButton = 'GUIDED_VIEW_VIEW_ALL_BUTTON',
  GuidedViewTabsScrollLeftButton = 'GUIDED_VIEW_SCROLL_LEFT_BUTTON',
  GuidedViewTabsScrollRightButton = 'GUIDED_VIEW_SCROLL_RIGHT_BUTTON',
  GuidedViewTabsButton = 'GUIDED_VIEW_TABS_BUTTON',
  GuidedViewSwitchButton = 'GUIDED_VIEW_SWITCH_BUTTON',
  GuidedViewColourCardLevel3 = 'GUIDED_VIEW_COLOUR_CARD_LEVEL_3',
  GuidedViewColourCardLevel4 = 'GUIDED_VIEW_COLOUR_CARD_LEVEL_4',
  GuidedViewNonColourCard = 'GUIDED_VIEW_NON_COLOUR_CARD',
  GuidedViewChip = 'GUIDED_VIEW_CHIP',
  GuidedViewDropDownLevel3 = 'GUIDED_VIEW_DROPDOWN_LEVEL_3',
  GuidedOfferingChoiceButton = 'GUIDED_OFFERING_CHOICE_BUTTON',
  GuidedOfferingInfoIcon = 'GUIDED_OFFERING_INFO_ICON',
  GuidedOfferingInfoReadMoreText = 'GUIDED_OFFERING_INFO_READ_MORE_TEXT',
  GuidedOfferingLoadingTruck = 'GUIDED_OFFERING_LOADING_TRUCK',
  GuidedOfferingNavigationPrevious = 'GUIDED_OFFERING_NAVIGATION_PREVIOUS',
  GuidedOfferingNavigationQuickStart = 'GUIDED_OFFERING_NAVIGATION_QUICK_START',
  GuidedOfferingNavigationRestart = 'GUIDED_OFFERING_NAVIGATION_RESTART',
  GuidedOfferingNavigationSkip = 'GUIDED_OFFERING_NAVIGATION_SKIP',
  HeaderAccountIcon = 'HEADER_ACCOUNT_ICON',
  HeaderInfoIcon = 'HEADER_INFO_ICON',
  HeaderLogoType = 'HEADER_LOGOTYPE',
  HeaderLogoTypeIcon = 'HEADER_LOGOTYPE_ICON',
  HeaderMarketName = 'HEADER_MARKETNAME',
  LandingPageStartFactoryModelsButton = 'LANDING_PAGE_START_FACTORY_MODELS_BUTTON',
  LandingPageStartGuidedOfferingBevButton = 'LANDING_PAGE_START_GUIDED_OFFERING_BEV_BUTTON',
  LandingPageStartGuidedOfferingButton = 'LANDING_PAGE_START_GUIDED_OFFERING_BUTTON',
  LinkDisclaimer = 'LINK_DISCLAIMER',
  LinkLegal = 'LINK_LEGAL',
  OverviewSummary = 'OVERVIEW_SUMMARY',
  OverviewConfigureTruckButton = 'OVERVIEW_CONFIGURE_TRUCK_BUTTON',
  SidePanel = 'SIDE_PANEL',
  SidePanelClose = 'SIDE_PANEL_CLOSE',
  SidePanelSaveAsGarageTruckNameInput = 'SIDE_PANEL_SAVE_AS_GARAGE_TRUCK_NAME_INPUT',
  SidePanelSaveAsGarageSaveButton = 'SIDE_PANEL_SAVE_AS_GARAGE_SAVE_BUTTON',
  SidePanelSaveGarageCard = 'SIDE_PANEL_SAVE_GARAGE_CARD',
  SidePanelSaveGarageLoginButton = 'SIDE_PANEL_SAVE_GARAGE_LOGIN_BUTTON',
  SidePanelSaveGarageSaveButton = 'SIDE_PANEL_SAVE_GARAGE_SAVE_BUTTON',
  SidePanelSaveImageCard = 'SIDE_PANEL_SAVE_IMAGE_CARD',
  SidePanelSaveImageDownloadButton = 'SIDE_PANEL_SAVE_IMAGE_DOWNLOAD_BUTTON',
  SidePanelSaveImageJpgRadioButton = 'SIDE_PANEL_SAVE_IMAGE_JPG_RADIO_BUTTON',
  SidePanelSaveImagePngRadioButton = 'SIDE_PANEL_SAVE_IMAGE_PNG_RADIO_BUTTON',
  SidePanelSavePdfCard = 'SIDE_PANEL_SAVE_PDF_CARD',
  SidePanelSavePdfDownloadButton = 'SIDE_PANEL_SAVE_PDF_DOWNLOAD_BUTTON',
  SidePanelSaveQrCard = 'SIDE_PANEL_SAVE_QR_CARD',
  SidePanelSaveQrDownloadButton = 'SIDE_PANEL_SAVE_QR_DOWNLOAD_BUTTON',
  SidePanelSaveQrPngRadioButton = 'SIDE_PANEL_SAVE_QR_PNG_RADIO_BUTTON',
  SidePanelSaveQrSvgRadioButton = 'SIDE_PANEL_SAVE_QR_SVG_RADIO_BUTTON',
  SidePanelSaveXmlCard = 'SIDE_PANEL_SAVE_XML_CARD',
  SidePanelSaveXmlDownloadButton = 'SIDE_PANEL_SAVE_XML_DOWNLOAD_BUTTON',
  SidePanelShareEmailCard = 'SIDE_PANEL_SHARE_EMAIL_CARD',
  SidePanelShareEmailFormPersonalMessageInput = 'SIDE_PANEL_SHARE_EMAIL_FORM_PERSONAL_MESSAGE_INPUT',
  SidePanelShareEmailFormRecipientEmailInput = 'SIDE_PANEL_SHARE_EMAIL_FORM_RECIPIENT_EMAIL_INPUT',
  SidePanelShareEmailFormRecipientNameInput = 'SIDE_PANEL_SHARE_EMAIL_FORM_RECIPIENT_NAME_INPUT',
  SidePanelShareEmailFormSenderEmailInput = 'SIDE_PANEL_SHARE_EMAIL_FORM_SENDER_EMAIL_INPUT',
  SidePanelShareEmailFormSenderFirstNameInput = 'SIDE_PANEL_SHARE_EMAIL_FORM_SENDER_FIRST_NAME_INPUT',
  SidePanelShareEmailFormSenderLastNameInput = 'SIDE_PANEL_SHARE_EMAIL_FORM_SENDER_LAST_NAME_INPUT',
  SidePanelShareEmailSubmitButton = 'SIDE_PANEL_SHARE_EMAIL_SUBMIT_BUTTON',
  SidePanelShareFacebookButton = 'SIDE_PANEL_SHARE_FACEBOOK_BUTTON',
  SidePanelShareFacebookCard = 'SIDE_PANEL_SHARE_FACEBOOK_CARD',
  SidePanelShareLinkButton = 'SIDE_PANEL_SHARE_LINK_BUTTON',
  SidePanelShareLinkCard = 'SIDE_PANEL_SHARE_LINK_CARD',
  SidePanelShareWhatsAppButton = 'SIDE_PANEL_SHARE_WHATSAPP_BUTTON',
  SidePanelShareWhatsAppCard = 'SIDE_PANEL_SHARE_WHATSAPP_CARD',
  SubHeaderActiveChoicesButton = 'SUBHEADER_ACTIVE_CHOICES_BUTTON',
  SubHeaderGoBackButton = 'SUBHEADER_GO_BACK_BUTTON',
  SubHeaderKebabButton = 'SUBHEADER_KEBAB_BUTTON',
  SubHeaderSearch = 'SUBHEADER_SEARCH',
  SummaryLeftSection = 'SUMMARY_LEFT_SECTION',
  SummaryRightSection = 'SUMMARY_RIGHT_SECTION',
  SummaryGetConsultationButton = 'SUMMARY_GET_CONSULTATION_BUTTON',
  SummaryGoBackButton = 'SUMMARY_GO_BACK_BUTTON',
  SummaryPrintButton = 'SUMMARY_PRINT_BUTTON',
  SummaryShareButton = 'SUMMARY_SHARE_BUTTON',
  TextTermsAndCondition = 'TEXT_TERMS_AND_CONDITIONS',
  UploadConfigButton = 'UPLOAD_CONFIG_BUTTON',
  UploadConfigFileSelector = 'UPLOAD_CONFIG_FILE_SELECTOR',
  UploadConfigLoadButton = 'UPLOAD_CONFIG_LOAD_BUTTON',
  UploadConfigModal = 'UPLOAD_CONFIG_MODAL',
}

export const TEST_GO_GROUP_ID_DONE_BUTTON = 'TEST_GO_GROUP_ID_DONE_BUTTON'
